<template lang="pug">
    v-form(ref="form")
        v-divider(v-if="index===0")
        v-layout(row wrap pt-3 mb-2)
            v-flex(:md2="!globalPercentageDiscount" :sm2="!globalPercentageDiscount"
                :md5="globalPercentageDiscount" :sm5="globalPercentageDiscount"
            )
                v-text-field.mx-3(
                    v-model="quantity"
                    mask="########"
                    label="Cantidad"
                    @input="uploadQuantity"
                    :readonly="!editable"
                    :rules="[rules.validQuantityPrev, rules.validQuantityNext, rules.required]"
                    )
            v-flex(md3 sm4 v-if="!globalPercentageDiscount")
                v-select.mx-3(
                    v-model="discountSelected" 
                    :items="discountsOptions"
                    label="Tipo de descuento:"
                    @input="uploadDiscountType"
                    :readonly="!editable"
                    :rules="[rules.required]"
                    )
            v-flex(v-if="globalPercentageDiscount || discountSelected===1"
                :md2="!globalPercentageDiscount" :sm2="!globalPercentageDiscount"
                :md5="globalPercentageDiscount" :sm5="globalPercentageDiscount")
                v-text-field.mx-3(
                    v-model="discount"
                    mask="##"
                    label="Descuento en porcentaje:"
                    prefix="%"
                    @input="uploadDiscount"
                    :readonly="!editable"
                    :rules="[rules.percentage, rules.validDiscountPrev, rules.validDiscountNext, rules.required]"
                    )
            v-flex(v-else-if="!globalPercentageDiscount && (discountSelected===2)" md2 sm2)
                v-text-field.mx-3(
                    v-model="discount"
                    :mask="mixCurrencyMask(discount, 8)"
                    label="Descuento en precio:"
                    @input="uploadDiscount"
                    :readonly="!editable"
                    :rules="[rules.maxAmount, rules.validDiscountPrev, rules.validDiscountNext, rules.required]"
                    )
                    // prefix="$"
            v-flex(v-else md2 sm2)
                v-text-field.mx-3(disabled label="Descuento")
            v-flex(md2 sm2 v-if="!globalPercentageDiscount")
                v-text-field.mx-3(
                    v-model="applyDiscount[index]"
                    :mask="mixCurrencyMask(applyDiscount[index], 8)"
                    label="Precio resultante"
                    readonly
                    title="Precio unitario resultante luego de aplicar descuento"
                    )
            v-flex(md2 sm2 v-if="editable")
                //v-btn(color="error" icon dark title="Eliminar descuento"
                    @click="deteleCurrentDiscount(index)")
                    v-icon clear
                v-btn(color="error" icon outline title="Eliminar descuento"
                    @click="deteleCurrentDiscount(index)")
                    v-icon delete
                //v-icon(color="error" title="Eliminar descuento"
                    @click="deteleCurrentDiscount(index)") delete
        v-divider
            

</template>

<script>
import InputValidations from '@/mixins/InputValidations'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
export default {
    name: 'discount',
    props: {
        /**
         * @description
         */
        index: {
            type: Number,
            default: () => 0,
        },

        /**
         * @description
         */
        editable: {
            type: Boolean,
            default: () => true,
        },
    },
    data: function() {
        return {
            quantity: '',
            discountsOptions: [
                { value: 1, text: 'Porcentaje (%)' },
                { value: 2, text: 'Precio ($)' },
            ],
            discountSelected: '',
            discount: '',
            rules: {
                required: value => {
                    if (value === '' || value == null) {
                        return 'required'
                    } else {
                        return true
                    }
                },
                percentage: value => {
                    if (value === '' || parseInt(value) < 100) {
                        return true
                    } else {
                        return 'Porcentaje no puede ser mayor a 100'
                    }
                },
                maxAmount: value => {
                    if (value === '' || parseInt(value) < this.maxPriceDiscount)
                        return true
                    else
                        return 'Descuento no puede superar precio'
                },

                validDiscountPrev: value => {
                    if(value === '' || this.lengthArrayDiscounts === 1) return true
                    if (this.index === 0 ||
                        this.arrayDiscounts[this.index - 1].discount === "" ||
                        this.applyDiscount[this.index] < this.applyDiscount[this.index - 1])
                        return true
                    else
                        console.log(this.applyDiscount[this.index], 'no es menor que', this.applyDiscount[this.index - 1], '!!!')
                        return 'validDiscountPrev'
                },

                validDiscountNext: value => {
                    if(value === '' || this.lengthArrayDiscounts === 1) return true
                    if (this.index === this.lengthArrayDiscounts - 1 ||
                        this.arrayDiscounts[this.index + 1].discount === "" ||
                        this.applyDiscount[this.index] > this.applyDiscount[this.index + 1])
                        return true
                    else 
                        return 'validDiscountNext'
                },

                validQuantityPrev: value => { // HACER LO MISMO PERO PARA LAS CANTIDADES
                    if(value === '' || this.lengthArrayDiscounts === 1) return true
                    if (this.index === 0 ||
                        this.arrayDiscounts[this.index - 1].quantity === "" ||
                        parseInt(value) > parseInt(this.arrayDiscounts[this.index - 1].quantity))
                        return true
                    else
                        return 'validQuantityPrev'
                },

                validQuantityNext: value => {
                    if(value === '' || this.lengthArrayDiscounts === 1) return true
                    if (this.index === this.lengthArrayDiscounts - 1 ||
                        this.arrayDiscounts[this.index + 1].quantity === "" || 
                        parseInt(value) < parseInt(this.arrayDiscounts[this.index + 1].quantity)){
                        return true}
                    else 
                        return 'validQuantityNext'
                },
            },
        }
    },
    computed: {
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            maxPriceDiscount: 'maxPriceDiscount',
            arrayDiscountsUploads: 'arrayDiscountsUploads',
            globalPercentageDiscount: 'globalPercentageDiscount',
        }),
        ...mapGetters('WholesaleDiscountModule', {
            lengthArrayDiscounts: 'lengthArrayDiscounts',
            applyDiscount: 'applyDiscount',
            quantitiesSorted: 'quantitiesSorted',
        }),
    },
    methods: {
        ...mapActions('WholesaleDiscountModule', {
            setQuantity: 'setQuantity',
            setDiscountType: 'setDiscountType',
            setDiscount: 'setDiscount',
            deleteDiscount: 'deleteDiscount',
        }),

        deteleCurrentDiscount(index) {
            this.deleteDiscount(index)
        },

        uploadQuantity() {
            this.setQuantity({ index: this.index, quantity: this.quantity })
        },

        uploadDiscountType() {
            let payload = {
                index: this.index,
                discountType: this.discountSelected,
            }
            this.setDiscountType(payload)
        },

        uploadDiscount() {
            let payload = { index: this.index, discount: this.discount }
            this.setDiscount(payload)
        },
    },
    watch: {
        /**
         * @description
         */
        lengthArrayDiscounts: function(newVal, oldVal) {
                this.quantity = this.arrayDiscounts[this.index].quantity
                this.discountSelected = this.arrayDiscounts[this.index].discountType
                this.discount = this.arrayDiscounts[this.index].discount
        },

        // arrayDiscounts: function(newVal, oldVal){
        //     this.quantity = newVal[this.index].quantity
        //         this.discountSelected = newVal[this.index].discountType
        //         this.discount = newVal[this.index].discount
        // },

        discountSelected: function(newVal, oldVal) {
            if(oldVal === 1 || oldVal === 2){
            this.discount = ''
            this.uploadDiscount()
            }
        },
        /**
         * @description
         */
        quantitiesSorted: function(newVal, oldVal) {
            if (newVal) {
                this.quantity = this.arrayDiscounts[this.index].quantity
                this.discountSelected = this.arrayDiscounts[this.index].discountType
                this.discount = this.arrayDiscounts[this.index].discount
            }
        },

        arrayDiscountsUploads: function(newVal, oldVal) {
            this.quantity = this.arrayDiscounts[this.index].quantity
            this.discountSelected = this.arrayDiscounts[this.index].discountType
            this.discount = this.arrayDiscounts[this.index].discount
            //this.$refs.form.validate()
        },

        arrayDiscounts: function(newVal, oldVal){
            this.$refs.form.validate()
        },

        applyDiscount: function(){
            // console.log('estoy probando una cosilla')
            this.$refs.form.validate()
        }
    },
    components: {},
    mixins: [InputValidations, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        this.quantity = this.arrayDiscounts[this.index].quantity
        this.discountSelected = this.arrayDiscounts[this.index].discountType
        this.discount = this.arrayDiscounts[this.index].discount
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>